module.exports = __webpack_public_path__ + "img/2021_10_damde_saga_fin_web.dde334b3.jpg";